[
  {
    "id": "staly",
    "name": "Krąg Przywołań",
    "description": "Cały sprzęt twojej klasy, zwykłe szanse.",
    "rotation": [],
    "featuredRate": 0
  },
  {
    "id": "wyrozniony",
    "name": "Gwiazda Tygodnia",
    "description": "Co tydzień inny zestaw: przedmioty epickie i lepsze to w połowie przypadków przedmiot wyróżniony. Za odłamki kupisz wyróżniony przedmiot epicki.",
    "rotation": [
      [
        "miecz-rycerski",
        "runiczny-topor",
        "krysztalowy-kostur",
        "ciezka-kusza"
      ],
      [
        "tarcza-z-herbem",
        "tarcza-barbarzyncy",
        "otwarta-ksiega",
        "noz-do-rzucania"
      ],
      [
        "helm-rycerski",
        "futrzana-czapa",
        "kapelusz-nekromanty",
        "kaptur-zwiadowcy"
      ],
      [
        "peleryna-rycerska",
        "skora-wilka",
        "plaszcz-gwiazd",
        "plaszcz-cienia"
      ],
      [
        "dwureczny-miecz",
        "wielki-topor",
        "kostur",
        "kusza"
      ],
      [
        "napiersnik-rycerski",
        "kaftan-niedzwiedzi",
        "szata-gwiezdna",
        "pancerz-z-lusek"
      ],
      [
        "sabatony-herbowe",
        "okute-buciory",
        "buty-mgly",
        "ciche-buty"
      ]
    ],
    "rotationDays": 7,
    "featuredRate": 0.5,
    "featuredMinRarity": "epicki",
    "shop": {
      "rarity": "epicki",
      "cost": 120
    }
  }
]
